import cx from "classnames";
import React from "react";
import { useDrop } from "react-dnd";
import { I18n } from "react-redux-i18n";

import { SkipLogic } from "@common/components/skip-logic";
import { SkipLogicCondition, SkipLogicPredefinedControlType } from "@common/components/skip-logic/skip-logic.types";

import "./conditions-builder.styles.scss";

type QueryCreatingConditionsBuilderProps = {
  className?: string;
  moduleName: string;
  conditions: Array<SkipLogicCondition>;
  onChange: (conditions: SkipLogicCondition[]) => void;
  onAllConditionsRemove: () => void;
};

export const QueryCreatingConditionsBuilder: React.FC<QueryCreatingConditionsBuilderProps> = ({
  className,
  moduleName,
  conditions,
  onChange,
  onAllConditionsRemove
}) => {
  const [{}, dropRef] = useDrop({
    accept: "field",
    collect: (monitor) => ({
      isOver: !!monitor.isOver(),
      canDrop: !!monitor.canDrop(),
    }),
  });

  return (
    <div className={cx("QueryCreatingConditionsBuilder", className)} ref={dropRef}>
      {!conditions.length && <span className="QueryCreatingConditionsBuilder__drag-drop-message">{I18n.t("Drag Fields From Warehouse And Drop Here")}</span>}
      <SkipLogic
        moduleName={moduleName}
        className="QueryCreatingConditionsBuilder__skip-logic"
        conditions={conditions}
        onRemove={onChange}
        onChange={onChange}
        onAdd={() => {}}
        getFolders={() => {
          return Promise.resolve([]);
        }}
        getFields={() => {
          return Promise.resolve([]);
        }}
        controls={[
          { type: SkipLogicPredefinedControlType.moveUp, handler: onChange },
          { type: SkipLogicPredefinedControlType.moveDown, handler: onChange },
          { type: SkipLogicPredefinedControlType.removeAll, handler: onAllConditionsRemove },
        ]}
      />
    </div>
  );
};
